// @core/api/endpoints/project/delete_board.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/project';

/**
 * Delete board
 * Deletes a board from the project. The default board cannot be deleted. Items remain in the project but lose their board position.
 */
export async function DeleteBoard(
  project_id: string,
  board_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/projects/:project_id/boards/:board_id`;
  requestPath = requestPath.replace(':project_id', encodeURIComponent(project_id));
  requestPath = requestPath.replace(':board_id', encodeURIComponent(board_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
